<div class="adx-dashboard-container">
  <!-- Header -->
  <app-public-header></app-public-header>
  <!-- Main Content -->
  <app-public-main class="adx-main-content" [publicViewConfiguration]="publicViewConfiguration"></app-public-main>
</div>
